<ng-template #searchOutletTemplete>
    <modal-content>
        <div class="search-outlet">
            <div class="bg-col-w p-t-10 p-b-10"
                 [grid]="10"
                 [ngSwitch]="!!(productListing?.models?.length )">

                <div [gridColumn]="3"
                     class="p-l-10">
                    <ng-container *ngSwitchCase="true">

                        <div class="m-b-10"
                             *ngIf="result?.terms">
                            <p class="s1"
                               translate>Suggested Results</p>
                            <div>
                                @for (term of result.terms; track term) {
                                <a class="block p2 term m-t-3"
                                   [routerLink]="term.redirect || ['search', term.barePhrase]"
                                   [innerHtml]="term.phrase"></a>
                                }
                            </div>
                        </div>

                    </ng-container>
                    <ng-container *ngSwitchCase="false">
                        <div *ngIf="popularTerms?.length"
                             class="m-b-10">

                            <h4 class="s1"
                                *ngIf="popularTerms?.length"
                                translate>Popular</h4>
                            @for (term of popularTerms; track term) {
                            <a class="p2 block m-t-3"
                               [routerLink]="['search', term]">{{term}}</a>
                            }


                        </div>
                    </ng-container>
                    <search-links class="block"></search-links>
                </div>

                <div [gridColumn]="7"
                     class="p-r-10">
                    <ng-container *ngSwitchCase="true">
                        <div class="flex flex-justify-between">
                            <p class="s1"
                               translate>Trending Products</p>
                            <a *ngIf="result?.term"
                               [routerLink]="['search', result.term]"
                               class="button-inline p2">{{'View all' | translate}}</a>
                        </div>
                        <div class="m-t-3 animation-reveal is-animate search-products"
                             cy-quickSearchProductListing
                             *ngIf="productListing?.models">
                            <div [grid]="4"
                                 [gridColumnGap]="1">
                                @for (model of productListing.models | slice: 0 : 4; track model){
                                <product [model]="asLocalProduct(model)"
                                         [gridColumn]="1"
                                         [smallWishlist]="true"
                                         [smallText]="true"
                                         [hideSwatches]="true"></product>
                                }
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="false">
                        <search-trending class="block"></search-trending>
                    </ng-container>
                    <search-banner class="block m-t-5"
                                   [term]="result?.term"></search-banner>
                </div>
            </div>
        </div>
    </modal-content>
</ng-template>
